module.exports = __webpack_public_path__ + "img/deepnatural.785696ff.png";